import React, { useEffect } from 'react';
import QuoteModal from './QuoteModal';
import { createRoot } from 'react-dom/client';
import useStore from './store';
const ModalWrapper = () => {
    const { isOpen, setOpen, setClose } = useStore();
    useEffect(() => {
        const checkHash = () => {
            console.log("NEW HASH:", window.location.hash);
            if (window.location.hash === '#quote') {
                setOpen();
            }
        };
        // Listen for hash changes
        window.addEventListener("hashchange", checkHash);
        return () => {
            window.removeEventListener("hashchange", checkHash);
        };
    }, []);
    useEffect(() => {
        const button = document.getElementById("quoteModalBtn");
        const links = document.querySelectorAll(".quote-link");
        const openHandler = () => setOpen();
        //Add click event handlers
        if (button)
            button.addEventListener("click", () => openHandler());
        links.forEach(link => link.addEventListener("click", () => openHandler()));
        return () => {
            if (button)
                button.removeEventListener("click", () => openHandler());
            links.forEach(link => link.removeEventListener("click", () => openHandler()));
        };
    }, []);
    if (!document.getElementById("quoteModalBtn"))
        return null;
    return React.createElement(QuoteModal, { isOpen: isOpen, onClose: () => setClose() });
};
const modalRoot = document.getElementById("quote-modal-root");
if (modalRoot) {
    //Mount the modal
    createRoot(modalRoot).render(React.createElement(ModalWrapper, null));
    const openQuoteModal = () => {
        if (window.location.hash === '#quote' ||
            window.location.pathname === '/quote' ||
            window.location.pathname === '/quote-form') {
            setTimeout(() => {
                var _a;
                const evt = new Event("click");
                (_a = document.getElementById("quoteModalBtn")) === null || _a === void 0 ? void 0 : _a.dispatchEvent(evt);
            }, 100);
            history.replaceState(null, '', window.location.pathname + window.location.search);
        }
    };
    // Run on initial load
    openQuoteModal();
    // Also listen for hash changes
    //window.addEventListener('hashchange', openQuoteModal)
}
